import "babel-polyfill";
import "./libs/slick";
import "./libs/infiniteslidev2";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {headerActions} from "./modules/headerActions";
import {fullHeightPage} from "./modules/fullHeightPage";
import {stickyHeader} from "./modules/stickyHeader";
import {mobileNav} from "./modules/mobileNav";
import {animationOnScroll} from "./modules/animationOnScroll";
import {customSelect} from "./modules/customSelect";
import {postsSlider} from "./modules/postsSlider";
import {accordion} from "./modules/accordion";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";
import {countersAnimation} from "./modules/countersAnimation";
import {tableWrap} from "./modules/tableWrap";
import {sliderWithLinks} from "./modules/sliderWithLinks";
import {infoCardsSlider} from "./modules/infoCardsSlider";
import {customTestimonials} from "./modules/customTestimonials";
import {awardsSlider} from "./modules/awardsSlider";
import {parallax} from "./modules/parallax";
import {testimonialsSmallSlider} from "./modules/testimonialsSmallSlider";
import {filtersToggle} from "./modules/filtersToggle";
import {testsSlider} from "./modules/testsSlider";
import {anchors} from "./modules/anchors";
import {video} from "./modules/video";
import {mediaSingleSlider} from "./modules/mediaSingleSlider";
import {ourTeamSlider} from "./modules/ourTeamSlider";
import {mediaMentionsSlider} from "./modules/mediaMentionsSlider";
import {tabs} from "./modules/tabs";
import {popups} from "./modules/popups";
import {filtersReset} from "./modules/filtersReset";
import {testFilters} from "./modules/testFilters";
import {customForm} from "./modules/customForm";
import {filtersPosts} from "./modules/filtersPosts";
import {filtersResources} from "./modules/filtersResources";
import {testingCards} from "./modules/testingCards";


binder({
    bounds: {
        "html": [constants, fullHeightPage, headerActions],
        ".header": [stickyHeader, mobileNav],
        ".has-animation": animationOnScroll,
        "select": customSelect,
        ".posts-slider": postsSlider,
        ".accordion": accordion,
        ".copy-link": copyLinkToBuffer,
        ".has-counters-animation": countersAnimation,
        "table": tableWrap,
        ".slider-with-links": sliderWithLinks,
        ".info-cards-slider": infoCardsSlider,
        ".custom-testimonials": customTestimonials,
        ".awards-slider": awardsSlider,
        ".has-parallax": parallax,
        ".testimonials-small-slider": testimonialsSmallSlider,
        ".sidebar-btn.view-more": filtersToggle,
        ".tests-slider-holder": testsSlider,
        ".has-anchor, .anchors-nav": anchors,
        ".play-video": video,
        ".media-single-slider": mediaSingleSlider,
        ".our-team-slider": ourTeamSlider,
        ".media-mentions-slider": mediaMentionsSlider,
        ".tabs-holder": tabs,
        ".popup-link": popups,
        ".form-filters": filtersReset,
        ".holder-tests": testFilters,
        ".custom-form": customForm,
        ".holder-posts": filtersPosts,
        ".resources-section": filtersResources,
        ".testing-cards": testingCards
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js